import type { Components, Theme } from "@mui/material/styles";

export const MuiListItem: Components<Theme>["MuiListItem"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      alignItems: "start",
      position: "relative",
      backgroundColor: theme.palette.grey[50],
      "&:hover": {
        backgroundColor: theme.palette.grey[50],
      },
    }),
    divider: ({ theme }) => ({
      borderBottom: `1px solid ${theme.palette.grey[300]}`,
      "&:last-child": {
        borderBottom: "none",
      },
    }),
    dense: ({ theme }) => ({
      alignItems: "start",
      "& .MuiCheckbox-root": {
        padding: theme.spacing(0.25, 1.25),
      },
      "& .MuiListItemText-multiline": {
        margin: 0,
        paddingTop: 0,
      },
      "& .MuiListItemText-root": {
        margin: theme.spacing(0.25, 0),
      },
      "& .MuiListItem-root": {
        padding: 0,
      },
      "& .MuiButtonBase-root": {
        padding: theme.spacing(0, 0.625, 0, 0),
      },
    }),
    gutters: ({ theme }) => ({
      "&.MuiListItem-dense": {
        paddingLeft: theme.spacing(1.25),
        paddingRight: theme.spacing(1.25),
      },
    }),
  },
};
